import { render, staticRenderFns } from "./SupportTicketChats.vue?vue&type=template&id=51b74f5a&scoped=true"
import script from "./SupportTicketChats.vue?vue&type=script&lang=js"
export * from "./SupportTicketChats.vue?vue&type=script&lang=js"
import style0 from "./SupportTicketChats.vue?vue&type=style&index=0&id=51b74f5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b74f5a",
  null
  
)

export default component.exports